export default __webpack_public_path__ + "fonts/Agipo-Regular.woff2";